import script from "./NotesCellElementLite.vue?vue&type=script&setup=true&lang=ts"
export * from "./NotesCellElementLite.vue?vue&type=script&setup=true&lang=ts"

import "./NotesCellElementLite.vue?vue&type=style&index=0&id=12656b72&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-12656b72"]])

export default __exports__
import QTooltip from 'quasar/src/components/tooltip/QTooltip.js';
import qInstall from "../../../../../../node_modules/vue-cli-plugin-quasar/lib/runtime.auto-import.js";
qInstall(script, 'components', {QTooltip});
